<template>
    <CardRh :processando="processando">
        <div class="disciplina-falta-agrupada-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="cpfFaltaAgrupada" class="form-label">CPF somente numeros</label>
                        <input id="cpfFaltaAgrupada" v-model="cpf" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="CPF somente numeros" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-2" v-if="status">
                        <label for="statusFaltaAgrupada" class="form-label">Status</label>
                        <Multiselect id="statusFaltaAgrupada" v-model="status_id" :options="status_select"
                            :searchable="true" @change="refreshTable" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-1">
                        <label for="pelotaoFaltaAgrupada" class="form-label">Pelotao</label>
                        <input id="pelotaoFaltaAgrupada" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotao" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="porcentagemMinFaltaAgrupada" class="form-label">Porcentagem Minima</label>
                        <input id="porcentagemMinFaltaAgrupada" v-model="porcentagemMin" @keyup="apertouEnter"
                            type="number" class="form-control form-control-solid" placeholder="Porcentagem minima" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="porcentagemMaxFaltaAgrupada" class="form-label">Porcentagem Maxima</label>
                        <input id="porcentagemMaxFaltaAgrupada" v-model="porcentagemMax" @keyup="apertouEnter"
                            type="number" class="form-control form-control-solid" placeholder="Porcentagem maxima" />
                    </div>

                    <div class="col-12 col-lg-3 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <Pdf :service="service" :status="status_id" :disciplinaId="disciplinaId" :pelotao="pelotao"  :disciplina="disciplina"
                            :porcentagemMin="porcentagemMin" :porcentagemMax="porcentagemMax" />
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" :pesquisar="false">
                    <th>Aluno</th>
                    <th>Status</th>
                    <th>Pelotao</th>
                    <th>Quantidade</th>
                    <th>C.H.</th>
                    <th>C.H. Falta</th>
                    <th>Limite de Falta</th>
                    <th>Porcentagem</th>
                    <th style="min-width:130px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts"> 
import CardRh from "@/components/cards/ManzaCard.vue";
import FaltaService from "@/service/v1/sigap/FaltaService"; 
import { Options, Vue } from "vue-class-component"; 
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Multiselect from '@vueform/multiselect';
import Pdf from "./_Pdf.vue";
import { Prop } from 'vue-property-decorator';

@Options({
    name: "DisciplinaFaltaAgrupadaIndex",
    components: { CardRh, KDataTable, Multiselect, Pdf },
})
export default class DisciplinaFaltaAgrupadaIndex extends Vue {

    @Prop() readonly disciplina!: any;
    @Prop() readonly perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service: any = null;

    public parametros: any = null;
    public disciplinaId: any = null;
    public status_id: any = null;
    public status: any = null;
    public pelotao: any = null;
    public porcentagemMin: any = null;
    public porcentagemMax: any = null;
    public cpf = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    
    pushColunaAcoes() {
        this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.cpf = '';
        this.status_id = null;
        this.pelotao = null;
        this.porcentagemMin = null;
        this.porcentagemMax = null;
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.service = new FaltaService();
        this.getStatus();
        this.disciplinaId = this.$route.params.id;
        this.config.ajax = {
            url: this.service.getApiUrl() + '/GetFaltaAgrupadas',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    cpf: this.cpf,
                    status: this.status_id,
                    pelotao: this.pelotao,
                    disciplinaId: this.disciplinaId,
                    porcentagemMin: this.porcentagemMin,
                    porcentagemMax: this.porcentagemMax,
                    search: d.search.value,
                };
                return dados;
            }
        };

        this.config.columns = [
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'matricula', name: 'matricula', class: 'desktop', orderable: false },
            { data: 'count', name: 'count', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', class: 'desktop', orderable: false },
            { data: 'disciplina', name: 'disciplina', searchable: false, class: 'text-center desktop', orderable: false },
            { data: 'porcentagem', name: 'porcentagem', searchable: false, class: 'text-center desktop' , orderable: false},
        ];
        this.config.columnDefs = [
            {
                targets: 0,
                render: (row) => {
                    return row != null ? row.usuario.nome : '';
                }
            },
            {
                targets: 1,
                render: (row) => {
                    return row != null ? row.status.nome : '';
                }
            },
            {
                targets: 2,
                render: (row) => {
                    return row != null ? row.pelotao : '';
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row != null ? row.cargaHoraria : '';
                }
            },
            {
                targets: 5,
                render: (row) => {
                    return row != null ? row.cargaHorariaLimpa : '';
                }
            },
            {
                targets: 6,
                render: (row) => {
                    return row != null ? row.qteLimiteFalta : '';
                }
            },
            {
                targets: 7,
                render: (row) => {
                    return row != null ? `${row.toFixed(2)}% de falta` : '';
                }
            }
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs.push(
                {
                    targets: 8,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-falta ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                }
            );
        }
    }
}
</script>

<style scoped>
.disciplina-falta-agrupada-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
